import { render } from "./shift.vue?vue&type=template&id=1006af46"
import script from "./shift.vue?vue&type=script&lang=js"
export * from "./shift.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__